import { render, staticRenderFns } from "./StartForm19.vue?vue&type=template&id=d90dd3d2&scoped=true"
import script from "./StartForm19.vue?vue&type=script&lang=ts"
export * from "./StartForm19.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d90dd3d2",
  null
  
)

export default component.exports